export const OrganizationsRoutes = [
  {
    path: "organizations",
    name: "organizations",
    component: () => import("@/domain/Organizations/presentation/pages/OrganizationsListPage.vue"),
    meta: { requiresAuth: true, permissions: "organizations.read" },
  },
  {
    path: "organizations/:id",
    name: "editOrganization",
    component: () => import("@/domain/Organizations/presentation/pages/OrganizationDetailPage.vue"),
    meta: { requiresAuth: true, permissions: "organizations.read" },
  },
];
